import Loader from "components/shared/loader";
import { plainDate } from "helpers/date";
import { featureModuleTypesEnum } from "helpers/enums/featureModuleTypes";
import { tripSheetFactSources, tripSheetFactSourcesEnum } from "helpers/enums/tripSheetFactSources";
import {
    tripSheetInspectionRecordMethods,
    tripSheetInspectionRecordMethodsEnum,
} from "helpers/enums/tripSheetInspectionRecordMethods";
import {
    tripSheetMedicalInspectionResults,
    tripSheetMedicalInspectionResultsEnum,
} from "helpers/enums/tripSheetMedicalInspectionResults";
import {
    tripSheetMedicalInspectionTypes,
    tripSheetMedicalInspectionTypesEnum,
} from "helpers/enums/tripSheetMedicalInspectionTypes";
import { tripSheetStatusesEnum } from "helpers/enums/tripSheetStatuses";
import {
    tripSheetTechnicalInspectionResults,
    tripSheetTechnicalInspectionResultsEnum,
} from "helpers/enums/tripSheetTechnicalInspectionResults";
import {
    tripSheetTechnicalInspectionTypes,
    tripSheetTechnicalInspectionTypesEnum,
} from "helpers/enums/tripSheetTechnicalInspectionTypes";
import { paths } from "helpers/paths";
import policy from "policies";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { namesList as driverNamesList } from "sources/books/drivers";
import { getAssignmentPoints, getPersonName, pointAddress } from "./model";

const own = (object, key) => Object.hasOwn(object || {}, key);
const fieldKey = (object, keys) => keys.find((key) => own(object, key)) || keys[0];
const fieldValue = (object, keys) => object?.[fieldKey(object, keys)] ?? "";
const withField = (object, keys, value) => ({
    ...object,
    [fieldKey(object, keys)]: value,
});
const shiftMileage = (shift) => {
    if (shift.actualMileage !== null && shift.actualMileage !== undefined) {
        return shift.actualMileage;
    }
    const start = fieldValue(shift, ["odometerOnStart"]);
    const end = fieldValue(shift, ["odometerOnEnd"]);
    if (start === "" || end === "" || !Number.isFinite(Number(start)) || !Number.isFinite(Number(end))) {
        return "";
    }
    return Number(end) - Number(start);
};
const MedicalInspections = ({
    shift,
    shiftIndex,
    canEditFacts,
    onChange,
    renderField,
    renderSelect,
    renderDateField,
}) => {
    const inspectionsKey = "medicalInspections";
    const inspections = shift[inspectionsKey] || [];
    const updateInspection = (index, value) => {
        const next = [...inspections];
        next[index] = value;
        onChange({
            ...shift,
            [inspectionsKey]: next,
        });
    };
    return (
        <div className="border-top mt-2 pt-2">
            <div className="font-weight-bold small my-3">Медицинские осмотры водителя</div>
            {inspections.map((inspection, inspectionIndex) => (
                <div className="border rounded p-2 mb-2" key={inspection.id || inspectionIndex}>
                    <div>
                        {renderSelect({
                            label: "Вид осмотра",
                            value: fieldValue(inspection, ["type"]),
                            options: tripSheetMedicalInspectionTypes,
                            disabled: !canEditFacts,
                            inputProps: {
                                name: `medicalInspectionType_${shiftIndex}_${inspectionIndex}`,
                            },
                            onChange: ({ value }) =>
                                updateInspection(inspectionIndex, withField(inspection, ["type"], value)),
                        })}
                        {renderDateField({
                            label: "Дата и время",
                            value: fieldValue(inspection, ["inspectedAt"]),
                            inPortal: true,
                            libOptions: {
                                autoComplete: "off",
                            },
                            disabled: !canEditFacts,
                            inputProps: {
                                name: `medicalInspection_${shiftIndex}_${inspectionIndex}`,
                                type: "datetime",
                            },
                            onChange: ({ value }) =>
                                updateInspection(
                                    inspectionIndex,
                                    withField(inspection, ["inspectedAt"], plainDate(value)),
                                ),
                        })}
                        {renderSelect({
                            label: "Результат",
                            value: fieldValue(inspection, ["result"]),
                            options: tripSheetMedicalInspectionResults,
                            disabled: !canEditFacts,
                            inputProps: {
                                name: `medicalInspectionResult_${shiftIndex}_${inspectionIndex}`,
                            },
                            onChange: ({ value }) =>
                                updateInspection(inspectionIndex, withField(inspection, ["result"], value)),
                        })}
                        {renderField({
                            label: "Медицинский работник",
                            value: fieldValue(inspection, ["medicalWorkerFullName"]),
                            disabled: !canEditFacts,
                            inputProps: {
                                name: `medicalWorker_${shiftIndex}_${inspectionIndex}`,
                            },
                            onChange: ({ value }) =>
                                updateInspection(
                                    inspectionIndex,
                                    withField(inspection, ["medicalWorkerFullName"], value),
                                ),
                        })}
                        {renderField({
                            label: "Медицинская организация",
                            value: fieldValue(inspection, ["medicalOrganizationName"]),
                            disabled: !canEditFacts,
                            inputProps: {
                                name: `medicalOrganization_${shiftIndex}_${inspectionIndex}`,
                            },
                            onChange: ({ value }) =>
                                updateInspection(
                                    inspectionIndex,
                                    withField(inspection, ["medicalOrganizationName"], value),
                                ),
                        })}
                        {renderSelect({
                            label: "Способ фиксации",
                            value: fieldValue(inspection, ["recordMethod"]),
                            options: tripSheetInspectionRecordMethods,
                            disabled: !canEditFacts,
                            inputProps: {
                                name: `medicalRecordMethod_${shiftIndex}_${inspectionIndex}`,
                            },
                            onChange: ({ value }) =>
                                updateInspection(inspectionIndex, withField(inspection, ["recordMethod"], value)),
                        })}
                        {renderField({
                            label: "Комментарий",
                            textarea: true,
                            value: inspection.comment,
                            disabled: !canEditFacts,
                            inputProps: {
                                name: `medicalComment_${shiftIndex}_${inspectionIndex}`,
                            },
                            onChange: ({ value }) =>
                                updateInspection(inspectionIndex, {
                                    ...inspection,
                                    comment: value,
                                }),
                        })}
                    </div>
                    {canEditFacts && (
                        <button
                            type="button"
                            className="btn btn-outline-danger btn-xs"
                            onClick={() =>
                                onChange({
                                    ...shift,
                                    [inspectionsKey]: inspections.filter((_, index) => index !== inspectionIndex),
                                })
                            }
                        >
                            Удалить осмотр
                        </button>
                    )}
                </div>
            ))}
            {inspections.length === 0 && <div className="text-muted small mb-2">Осмотры не заполнены</div>}
            {canEditFacts && (
                <button
                    type="button"
                    className="btn btn-secondary btn-xs"
                    onClick={() =>
                        onChange({
                            ...shift,
                            [inspectionsKey]: [
                                ...inspections,
                                {
                                    type: tripSheetMedicalInspectionTypesEnum.PreTrip,
                                    isRequired: true,
                                    result: tripSheetMedicalInspectionResultsEnum.NotCompleted,
                                    recordMethod: tripSheetInspectionRecordMethodsEnum.InSystem,
                                },
                            ],
                        })
                    }
                >
                    Добавить медицинский осмотр
                </button>
            )}
        </div>
    );
};

/** Editor for documentary driver-shift snapshots, including crew and handover facts. */
const DriverShiftsSection = ({
    shifts,
    assignments,
    onChange,
    canEditPlan,
    canEditFacts,
    renderField,
    renderSelect,
    renderCheckbox,
    renderDateField,
}) => {
    const { roles, profile } = useSelector((state) => state.profile);
    const { availableFeatureModules, limitedFunctionality } = profile;
    const couplingPolicy = policy("path", {
        user: { roles },
        record: {},
        options: { availableFeatureModules, limitedFunctionality },
    });
    const canSeeCouplings = couplingPolicy.canSeeCouplings();
    const couplingModuleUnavailable = availableFeatureModules?.includes(featureModuleTypesEnum.TripCoupling) === false;
    // Keep the policy's role and functionality restrictions when distinguishing a missing module.
    const couplingAccessReason =
        couplingModuleUnavailable &&
        couplingPolicy.canSeeCouplings({
            options: { availableFeatureModules: [featureModuleTypesEnum.TripCoupling], limitedFunctionality },
        })
            ? "Раздел «Сцепки» доступен с модулем «Смены». Смены водителей в путевом листе можно добавить вручную"
            : "Раздел «Сцепки» вам недоступен. Смены водителей в путевом листе можно добавить вручную";
    const routePointOptions = (assignments || []).reduce((options, assignment, assignmentIndex) => {
        getAssignmentPoints(assignment).forEach((point, pointIndex) => {
            const routePointId = Number(point.id);
            if (!Number.isSafeInteger(routePointId) || routePointId <= 0) {
                return;
            }
            const assignmentName = assignment.bidNumber
                ? `Заявка ${assignment.bidNumber}`
                : `Задание ${assignmentIndex + 1}`;
            const sequenceNumber = point.sequenceNumber || pointIndex + 1;
            const address = pointAddress(point);
            options.push({
                value: routePointId,
                label: `${assignmentName}, точка ${sequenceNumber}${address ? `: ${address}` : ""}`,
            });
        });
        return options;
    }, []);
    const routePointInputBottomText =
        routePointOptions.length === 0 ? (
            <small className="text-muted">В путевом листе пока нет маршрутных точек с присвоенным ID.</small>
        ) : null;
    const updateShift = (index, shift) => {
        const next = [...shifts];
        next[index] = shift;
        onChange(next);
    };
    const updateOdometer = (index, shift, valueKeys, sourceKeys, value) => {
        let nextShift = withField(shift, valueKeys, value);
        const source = fieldValue(shift, sourceKeys);
        if (source === tripSheetFactSourcesEnum.Telematics) {
            nextShift = withField(nextShift, sourceKeys, tripSheetFactSourcesEnum.Corrected);
        } else if (!source && value !== "") {
            nextShift = withField(nextShift, sourceKeys, tripSheetFactSourcesEnum.Manual);
        }
        updateShift(index, nextShift);
    };
    return (
        <div>
            {shifts.map((shift, index) => (
                <div
                    className="border rounded p-3 mb-3"
                    key={shift.id || `${shift.tripCouplingId || "shift"}_${index}`}
                >
                    <div className="d-flex justify-content-between align-items-center mb-2">
                        <strong>Смена {fieldValue(shift, ["sequenceNumber"]) || index + 1}</strong>
                        {shift.tripCouplingId && (
                            <span className="badge badge-light">Сцепка #{shift.tripCouplingId}</span>
                        )}
                    </div>
                    <div>
                        {renderSelect({
                            label: "Водитель",
                            url: driverNamesList,
                            propName: "fullName",
                            menuPortalTarget: document.body,
                            value: fieldValue(shift, ["driverId"]),
                            disabled: !canEditPlan,
                            inputProps: {
                                name: `driverShift_${index}`,
                            },
                            onChange: ({ value }) => updateShift(index, withField(shift, ["driverId"], value)),
                        })}
                        {renderDateField({
                            label: "Плановое начало",
                            value: fieldValue(shift, ["plannedStartedAt"]),
                            disabled: !canEditPlan,
                            inputProps: {
                                name: `plannedStartAt_${index}`,
                                type: "datetime",
                            },
                            onChange: ({ value }) =>
                                updateShift(index, withField(shift, ["plannedStartedAt"], plainDate(value))),
                        })}
                        {renderDateField({
                            label: "Плановое окончание",
                            value: fieldValue(shift, ["plannedEndedAt"]),
                            disabled: !canEditPlan,
                            inputProps: {
                                name: `plannedEndAt_${index}`,
                                type: "datetime",
                            },
                            onChange: ({ value }) =>
                                updateShift(index, withField(shift, ["plannedEndedAt"], plainDate(value))),
                        })}
                        {renderDateField({
                            label: "Фактическое начало",
                            value: fieldValue(shift, ["actualStartedAt"]),
                            disabled: !canEditFacts,
                            inputProps: {
                                name: `actualStartAt_${index}`,
                                type: "datetime",
                            },
                            onChange: ({ value }) =>
                                updateShift(index, withField(shift, ["actualStartedAt"], plainDate(value))),
                        })}
                        {renderDateField({
                            label: "Фактическое окончание",
                            value: fieldValue(shift, ["actualEndedAt"]),
                            disabled: !canEditFacts,
                            inputProps: {
                                name: `actualEndAt_${index}`,
                                type: "datetime",
                            },
                            onChange: ({ value }) =>
                                updateShift(index, withField(shift, ["actualEndedAt"], plainDate(value))),
                        })}
                        {renderCheckbox({
                            label: "Признак экипажа",
                            value: !!fieldValue(shift, ["isCrew"]),
                            disabled: !canEditPlan,
                            inputProps: {
                                name: `isCrew_${index}`,
                            },
                            onChange: ({ value }) => updateShift(index, withField(shift, ["isCrew"], value)),
                        })}
                        {renderField({
                            label: "Место приёма автомобиля",
                            value: fieldValue(shift, ["startPlace"]),
                            disabled: !canEditFacts,
                            inputProps: {
                                name: `startPlace_${index}`,
                            },
                            onChange: ({ value }) => updateShift(index, withField(shift, ["startPlace"], value)),
                        })}
                        {renderSelect({
                            label: "Точка маршрута при приёме",
                            value: fieldValue(shift, ["startRoutePointId"]),
                            options: routePointOptions,
                            menuPortalTarget: document.body,
                            inputBottomText: routePointInputBottomText,
                            disabled: !canEditFacts || routePointOptions.length === 0,
                            inputProps: {
                                name: `startRoutePointId_${index}`,
                            },
                            onChange: ({ value }) =>
                                updateShift(index, withField(shift, ["startRoutePointId"], value || null)),
                        })}
                        {renderField({
                            label: "Место сдачи автомобиля",
                            value: fieldValue(shift, ["endPlace"]),
                            disabled: !canEditFacts,
                            inputProps: {
                                name: `endPlace_${index}`,
                            },
                            onChange: ({ value }) => updateShift(index, withField(shift, ["endPlace"], value)),
                        })}
                        {renderSelect({
                            label: "Точка маршрута при сдаче",
                            value: fieldValue(shift, ["endRoutePointId"]),
                            options: routePointOptions,
                            menuPortalTarget: document.body,
                            inputBottomText: routePointInputBottomText,
                            disabled: !canEditFacts || routePointOptions.length === 0,
                            inputProps: {
                                name: `endRoutePointId_${index}`,
                            },
                            onChange: ({ value }) =>
                                updateShift(index, withField(shift, ["endRoutePointId"], value || null)),
                        })}
                        {renderSelect({
                            label: "Автомобиль передал",
                            url: driverNamesList,
                            propName: "fullName",
                            menuPortalTarget: document.body,
                            value: fieldValue(shift, ["transferredByDriverId"]),
                            disabled: !canEditFacts,
                            inputProps: {
                                name: `transferredByDriver_${index}`,
                            },
                            onChange: ({ value }) =>
                                updateShift(index, withField(shift, ["transferredByDriverId"], value)),
                        })}
                        {renderSelect({
                            label: "Автомобиль принял",
                            url: driverNamesList,
                            propName: "fullName",
                            menuPortalTarget: document.body,
                            value: fieldValue(shift, ["acceptedByDriverId"]),
                            disabled: !canEditFacts,
                            inputProps: {
                                name: `receivedByDriver_${index}`,
                            },
                            onChange: ({ value }) =>
                                updateShift(index, withField(shift, ["acceptedByDriverId"], value)),
                        })}
                        {renderField({
                            label: "Одометр при приёме",
                            value: fieldValue(shift, ["odometerOnStart"]),
                            disabled: !canEditFacts,
                            inputProps: {
                                name: `odometerOnStart_${index}`,
                                type: "number",
                                min: 0,
                                step: "0.1",
                            },
                            onChange: ({ value }) =>
                                updateOdometer(index, shift, ["odometerOnStart"], ["odometerOnStartSource"], value),
                        })}
                        {renderSelect({
                            label: "Источник одометра при приёме",
                            value: fieldValue(shift, ["odometerOnStartSource"]),
                            options: tripSheetFactSources,
                            disabled: !canEditFacts,
                            inputProps: {
                                name: `odometerOnStartSource_${index}`,
                            },
                            onChange: ({ value }) =>
                                updateShift(index, withField(shift, ["odometerOnStartSource"], value)),
                        })}
                        {renderField({
                            label: "Причина корректировки при приёме",
                            textarea: true,
                            value: fieldValue(shift, ["odometerOnStartCorrectionReason"]),
                            disabled: !canEditFacts,
                            inputProps: {
                                name: `odometerOnStartCorrectionReason_${index}`,
                            },
                            onChange: ({ value }) =>
                                updateShift(index, withField(shift, ["odometerOnStartCorrectionReason"], value)),
                        })}
                        {renderField({
                            label: "Одометр при сдаче",
                            value: fieldValue(shift, ["odometerOnEnd"]),
                            disabled: !canEditFacts,
                            inputProps: {
                                name: `odometerOnEnd_${index}`,
                                type: "number",
                                min: 0,
                                step: "0.1",
                            },
                            onChange: ({ value }) =>
                                updateOdometer(index, shift, ["odometerOnEnd"], ["odometerOnEndSource"], value),
                        })}
                        {renderField({
                            label: "Причина корректировки при сдаче",
                            textarea: true,
                            value: fieldValue(shift, ["odometerOnEndCorrectionReason"]),
                            disabled: !canEditFacts,
                            inputProps: {
                                name: `odometerOnEndCorrectionReason_${index}`,
                            },
                            onChange: ({ value }) =>
                                updateShift(index, withField(shift, ["odometerOnEndCorrectionReason"], value)),
                        })}
                        {renderSelect({
                            label: "Источник одометра при сдаче",
                            value: fieldValue(shift, ["odometerOnEndSource"]),
                            options: tripSheetFactSources,
                            disabled: !canEditFacts,
                            inputProps: {
                                name: `odometerOnEndSource_${index}`,
                            },
                            onChange: ({ value }) =>
                                updateShift(index, withField(shift, ["odometerOnEndSource"], value)),
                        })}
                        {renderField({
                            label: "Фактический пробег смены",
                            value: shiftMileage(shift),
                            disabled: true,
                            inputProps: {
                                name: `actualMileage_${index}`,
                            },
                        })}
                        {renderField({
                            label: "Комментарий к передаче",
                            textarea: true,
                            value: fieldValue(shift, ["transferComment"]),
                            disabled: !canEditFacts,
                            inputProps: {
                                name: `transferComment_${index}`,
                            },
                            onChange: ({ value }) => updateShift(index, withField(shift, ["transferComment"], value)),
                        })}
                    </div>
                    <MedicalInspections
                        shift={shift}
                        shiftIndex={index}
                        canEditFacts={canEditFacts}
                        onChange={(value) => updateShift(index, value)}
                        renderField={renderField}
                        renderSelect={renderSelect}
                        renderDateField={renderDateField}
                    />
                    {canEditPlan && (
                        <button
                            type="button"
                            className="btn btn-outline-danger btn-xs mt-2"
                            onClick={() => onChange(shifts.filter((_, shiftIndex) => shiftIndex !== index))}
                        >
                            Удалить смену
                        </button>
                    )}
                </div>
            ))}
            {shifts.length === 0 && (
                <div className="alert alert-danger border py-2">
                    Смены не получены. Для старого документа отображаются совместимые поля основного и второго водителя.
                </div>
            )}
            {canEditPlan && (
                <div>
                    <button
                        type="button"
                        className="btn btn-secondary btn-sm"
                        onClick={() =>
                            onChange([
                                ...shifts,
                                {
                                    sequenceNumber: shifts.length + 1,
                                    medicalInspections: [],
                                },
                            ])
                        }
                    >
                        Добавить смену вручную
                    </button>
                    <div className="small text-muted mt-1">
                        {canSeeCouplings ? (
                            <>
                                Добавьте смены в{" "}
                                <Link to={paths.couplings} target="_blank" rel="noopener noreferrer">
                                    разделе «Сцепки»
                                </Link>
                                , затем перенесите их в путевой лист кнопкой «Обновить из сцепок»
                            </>
                        ) : (
                            couplingAccessReason
                        )}
                    </div>
                </div>
            )}
        </div>
    );
};

/** Explicit synchronization UI for documentary coupling snapshots. */
const CouplingsSection = ({
    data,
    source,
    status,
    canEditPlan,
    canEditFacts,
    trailerPeriods,
    reload,
    suggestionFrom,
    suggestionTo,
    formatDate = (value) => value,
    renderField,
    renderCheckbox,
}) => {
    const [suggestions, setSuggestions] = useState([]);
    const [selectedIds, setSelectedIds] = useState([]);
    const [preview, setPreview] = useState(null);
    const [reason, setReason] = useState("");
    const [error, setError] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const periodReady = (canEditPlan || canEditFacts) && data.carId && suggestionFrom && suggestionTo;
    useEffect(() => {
        if (!periodReady) {
            setSuggestions([]);
            setSelectedIds([]);
            return;
        }
        let isMounted = true;
        setIsLoading(true);
        source
            .getCouplingSuggestions({
                carId: data.carId,
                from: suggestionFrom,
                to: suggestionTo,
            })
            .then((items) => {
                if (!isMounted) {
                    return;
                }
                const nextItems = items || [];
                setSuggestions(nextItems);
                setSelectedIds(nextItems.map((item) => item.id));
            })
            .catch(() => isMounted && setSuggestions([]))
            .finally(() => isMounted && setIsLoading(false));
        return () => {
            isMounted = false;
        };
    }, [data.carId, periodReady, source, suggestionFrom, suggestionTo]);
    const loadPreview = () => {
        if (!data.id) {
            return;
        }
        setIsLoading(true);
        source
            .getCouplingSyncPreview(data.id)
            .then((value) => {
                setPreview(value || null);
                setError(value ? "" : "Не удалось получить расхождения со сцепками");
            })
            .catch(() => {
                setPreview(null);
                setError("Не удалось получить расхождения со сцепками");
            })
            .finally(() => setIsLoading(false));
    };
    const sync = () => {
        if (!data.id) {
            setError("Сначала сохраните путевой лист");
            return;
        }
        if (status === tripSheetStatusesEnum.Issued && !reason.trim()) {
            setError("Для синхронизации выданного листа укажите причину");
            return;
        }
        if (!preview) {
            setError("Перед синхронизацией просмотрите расхождения со сцепками");
            loadPreview();
            return;
        }
        setIsLoading(true);
        setError("");
        source
            .syncCouplings({
                id: data.id,
                tripCouplingIds: selectedIds,
                reason: reason.trim() || null,
            })
            .then((result) => {
                if (result) {
                    setPreview(null);
                    reload();
                }
            })
            .finally(() => setIsLoading(false));
    };
    const previewGroups = preview
        ? [
              ["Доступные", preview.availableTripCouplingIds],
              ["Связанные", preview.linkedTripCouplingIds],
              ["Новые", preview.newTripCouplingIds],
              ["Изменённые", preview.changedTripCouplingIds],
              ["Отсутствующие", preview.missingTripCouplingIds],
          ]
        : [];
    return (
        <div>
            {isLoading && <Loader prefix="absolute-center" />}
            {!periodReady && (canEditPlan || canEditFacts) && (
                <div className="text-muted">Выберите автомобиль и период.</div>
            )}
            {periodReady && suggestions.length === 0 && !isLoading && (
                <div className="text-muted my-2">Подходящие сцепки не найдены.</div>
            )}
            {suggestions.map((item) => (
                <div className="border rounded p-2 mb-2" key={item.id}>
                    {renderCheckbox({
                        label: `Сцепка #${item.id}: ${getPersonName(item.driver) || "водитель не указан"}`,
                        fieldBeforeLabel: true,
                        bWrapper: "d-flex align-items-start mb-0",
                        labelWrapper: "mb-0",
                        fieldWrapper: "mr-2",
                        checkboxWrapCname: "my-1",
                        value: selectedIds.includes(item.id),
                        disabled: !canEditPlan && !canEditFacts,
                        inputProps: {
                            name: `couplingSuggestion_${item.id}`,
                        },
                        onChange: ({ value }) =>
                            setSelectedIds((ids) => (value ? [...ids, item.id] : ids.filter((id) => id !== item.id))),
                    })}
                    <div className="small text-muted ml-4">
                        {item.secondaryDriver && `, ${getPersonName(item.secondaryDriver)}`}
                        {item.trailer?.number && `; прицеп ${item.trailer.number}`}
                        <span className="d-block">
                            {(item.startedAt && formatDate(item.startedAt)) || "начало не указано"} —{" "}
                            {(item.endedAt && formatDate(item.endedAt)) || "окончание не указано"}
                            {pointAddress(item.geozone) && `; ${pointAddress(item.geozone)}`}
                        </span>
                    </div>
                </div>
            ))}
            {preview && (
                <div className={`alert ${preview.hasChanges ? "alert-warning" : "alert-success"} py-2`}>
                    {preview.hasChanges ? "Найдены расхождения со снимком листа." : "Снимок соответствует сцепкам."}
                    {preview.isPairedCrewAvailable === false && (
                        <div>Модуль парных экипажей для организации недоступен.</div>
                    )}
                    {previewGroups.map(
                        ([label, ids]) =>
                            ids?.length > 0 && (
                                <div key={label}>
                                    {label}: {ids.join(", ")}
                                </div>
                            ),
                    )}
                </div>
            )}
            {trailerPeriods?.length > 0 && (
                <div className="mb-2">
                    <div className="small font-weight-bold mb-1">Зафиксированная история прицепов</div>
                    {trailerPeriods.map((period, index) => (
                        <div className="small text-muted" key={period.id || index}>
                            {period.trailer?.number || period.trailerNumber || `Период ${index + 1}`}:{" "}
                            {(period.startedAt && formatDate(period.startedAt)) || "—"}
                            {" — "}
                            {(period.endedAt && formatDate(period.endedAt)) || "—"}
                        </div>
                    ))}
                </div>
            )}
            {!canEditPlan && !canEditFacts && !trailerPeriods?.length && (
                <div className="text-muted">История сцепок и прицепов не заполнена.</div>
            )}
            {(canEditPlan || canEditFacts) && data.id && (
                <div>
                    {renderField({
                        label: "Причина синхронизации со сцепками",
                        textarea: true,
                        value: reason,
                        disabled: false,
                        inputProps: {
                            name: "couplingSyncReason",
                        },
                        onChange: ({ value }) => setReason(value),
                    })}
                    <div className="small text-muted mb-2">
                        Причина обязательна при принятии изменений в выданный лист.
                    </div>
                    {error && <div className="text-danger small mb-2">{error}</div>}
                    <button type="button" className="btn btn-secondary btn-sm mr-2" onClick={loadPreview}>
                        Показать расхождения
                    </button>
                    <button type="button" className="btn btn-secondary btn-sm" onClick={sync}>
                        Обновить из сцепок
                    </button>
                </div>
            )}
            {!data.id && suggestions.length > 0 && (
                <div className="small text-muted">Сохраните черновик, чтобы синхронизировать выбранные сцепки.</div>
            )}
        </div>
    );
};

/** Technical inspection events; negative results remain visible and backend validation blocks issue. */
const TechnicalInspectionsSection = ({
    inspections,
    onChange,
    canEditFacts,
    renderField,
    renderSelect,
    renderDateField,
}) => {
    const update = (index, value) => {
        const next = [...inspections];
        next[index] = value;
        onChange(next);
    };
    return (
        <div>
            {inspections.map((inspection, index) => (
                <div className="border rounded p-3 mb-2" key={inspection.id || index}>
                    <div>
                        {renderSelect({
                            label: "Вид контроля",
                            value: fieldValue(inspection, ["type"]),
                            options: tripSheetTechnicalInspectionTypes,
                            disabled: !canEditFacts,
                            inputProps: {
                                name: `technicalInspectionType_${index}`,
                            },
                            onChange: ({ value }) => update(index, withField(inspection, ["type"], value)),
                        })}
                        {renderDateField({
                            label: "Дата и время",
                            value: fieldValue(inspection, ["inspectedAt"]),
                            disabled: !canEditFacts,
                            inputProps: {
                                name: `technicalInspection_${index}`,
                                type: "datetime",
                            },
                            onChange: ({ value }) =>
                                update(index, withField(inspection, ["inspectedAt"], plainDate(value))),
                        })}
                        {renderSelect({
                            label: "Результат",
                            value: fieldValue(inspection, ["result"]),
                            options: tripSheetTechnicalInspectionResults,
                            disabled: !canEditFacts,
                            inputProps: {
                                name: `technicalInspectionResult_${index}`,
                            },
                            onChange: ({ value }) => update(index, withField(inspection, ["result"], value)),
                        })}
                        {renderField({
                            label: "Ответственное лицо",
                            value: fieldValue(inspection, ["responsibleFullName"]),
                            disabled: !canEditFacts,
                            inputProps: {
                                name: `technicalInspectionResponsible_${index}`,
                            },
                            onChange: ({ value }) =>
                                update(index, withField(inspection, ["responsibleFullName"], value)),
                        })}
                        {renderSelect({
                            label: "Способ фиксации",
                            value: fieldValue(inspection, ["recordMethod"]),
                            options: tripSheetInspectionRecordMethods,
                            disabled: !canEditFacts,
                            inputProps: {
                                name: `technicalInspectionRecordMethod_${index}`,
                            },
                            onChange: ({ value }) => update(index, withField(inspection, ["recordMethod"], value)),
                        })}
                        {renderField({
                            label: "Комментарий / причина запрета",
                            textarea: true,
                            value: inspection.comment,
                            disabled: !canEditFacts,
                            inputProps: {
                                name: `technicalInspectionComment_${index}`,
                            },
                            onChange: ({ value }) =>
                                update(index, {
                                    ...inspection,
                                    comment: value,
                                }),
                        })}
                    </div>
                    {canEditFacts && (
                        <button
                            type="button"
                            className="btn btn-outline-danger btn-xs"
                            onClick={() =>
                                onChange(inspections.filter((_, inspectionIndex) => inspectionIndex !== index))
                            }
                        >
                            Удалить контроль
                        </button>
                    )}
                </div>
            ))}
            {inspections.length === 0 && <div className="text-muted mb-2">Технический контроль не заполнен.</div>}
            {canEditFacts && (
                <button
                    type="button"
                    className="btn btn-secondary btn-sm"
                    onClick={() =>
                        onChange([
                            ...inspections,
                            {
                                type: tripSheetTechnicalInspectionTypesEnum.PreTrip,
                                result: tripSheetTechnicalInspectionResultsEnum.NotCompleted,
                                recordMethod: tripSheetInspectionRecordMethodsEnum.InSystem,
                            },
                        ])
                    }
                >
                    Добавить технический контроль
                </button>
            )}
        </div>
    );
};
export { CouplingsSection, DriverShiftsSection, TechnicalInspectionsSection };
